import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

const REGISTER_URL = "https://learn.ism.gov.in";
const SEEN_KEY = "ismBannerSeenForToken";

// A new login issues a new jwtToken, so remembering the token the banner was
// last shown for makes it appear once per login rather than on every visit.
function currentLoginId() {
  const token = localStorage.getItem("jwtToken");
  return token ? token.slice(-32) : null;
}

function shouldOpen(oncePerLogin) {
  if (!oncePerLogin) return true;
  try {
    const loginId = currentLoginId();
    return !!loginId && localStorage.getItem(SEEN_KEY) !== loginId;
  } catch (e) {
    return true;
  }
}

export default function IsmBannerPopup({ oncePerLogin = false }) {
  const [isOpen, setIsOpen] = useState(() => shouldOpen(oncePerLogin));

  useEffect(() => {
    if (!oncePerLogin || !isOpen) return;
    try {
      localStorage.setItem(SEEN_KEY, currentLoginId());
    } catch (e) {}
  }, [oncePerLogin, isOpen]);

  return (
    <Popup
      className="ism-banner"
      overlayStyle={{
        background: "rgba(0, 0, 0, 0.75)",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      trigger={<button style={{ display: "none" }}>Trigger</button>}
      position="center"
      open={isOpen}
      onClose={() => setIsOpen(false)}
    >
      <div style={{ position: "relative" }}>
        <button
          aria-label="Close"
          onClick={() => setIsOpen(false)}
          style={{
            position: "absolute",
            top: "-18px",
            right: "-18px",
            background: "white",
            border: "none",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            cursor: "pointer",
            zIndex: 10,
            boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 0,
          }}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="1"
              y1="1"
              x2="13"
              y2="13"
              stroke="#333"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <line
              x1="13"
              y1="1"
              x2="1"
              y2="13"
              stroke="#333"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <a href={REGISTER_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="/images/ism-semiconductors-banner.jpg"
            alt="Introduction to Semiconductors, a self-paced course by India Semiconductor Mission. Click here to register."
            style={{
              display: "block",
              width: "100%",
              borderRadius: "14px",
              boxShadow: "0 30px 80px rgba(0,0,0,0.6)",
            }}
          />
        </a>
      </div>
    </Popup>
  );
}
